import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Careers from "./Careers";
import {
  auth,
  db,
  googleProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  setPersistence,
  browserSessionPersistence
} from "./firebase";
import {
  onAuthStateChanged,
  signOut,
  isSignInWithEmailLink
} from "firebase/auth";
import { collection, addDoc, serverTimestamp, getDoc, doc, query, where, getDocs } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// --- IMPORTS ---
import NabiTraining from "./nabi_training";
import TherapistPage from "./therapist";
import VerifyEmail from "./VerifyEmail";
import NabiHealth from "./NabiHealth";
import Blogs from "./Blogs";
import About from "./About";
import NabiStore, { PRODUCTS } from "./NabiStore";
import UserProfile from "./UserProfile";
import TherapistDashboard from "./TherapistDashboard";
// IMPORT LEGAL PAGES
import TermsPage from "./TermsPage";
import PrivacyPage from "./PrivacyPage";
import ShippingreturnPage from "./Shippingreturnpage";
import { GoogleAuthProvider } from "firebase/auth/cordova";
// import { useLocation } from 'react-router-dom';

import Instagramfeeddata from "./Instagramfeeddata"
import routeComponents from "./AppRoutes";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, useOutletContext } from "react-router-dom"; // <-- NEW // <-- NEW
import "./Home.css";

// --- ASSETS ---
const APP_ASSETS = {
  logo: "/Nabi UI Assets/Assets_Images/Logo placeholder.png",
  instagram: "/Nabi UI Assets/Assets_Icon/Icon_Instagram.svg",
  linkedin: "/Nabi UI Assets/Assets_Icon/Icon_Linkedin.svg",
  heroButterfly: "image1.png"
};
const ASSETS = {
  icons: {

    cart: "/Nabi UI Assets/Assets_Icon/Icon_Cart.svg",
  }
};



export default function App() {
  const [view, setView] = useState("home");
  const [instaPosts, setInstaPosts] = useState([]);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [cvFile, setCvFile] = useState(null);
  const [knowImageHover, setKnowImageHover] = useState(false);
  const [storeInitialProductId, setStoreInitialProductId] = useState(null);
  const instaScrollRef = useRef(null);
  const storeCarouselRef = useRef(null);

  // --- CART STATE MOVED TO LAYOUT.JS ---

  // Auth States
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignUpMode, setIsSignUpMode] = useState(false);

  // Application Form State
  const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", message: "" });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [showCareerDetails, setShowCareerDetails] = useState(false);
  const storage = getStorage();

  const navigate = useNavigate();      // <-- NEW
  const location = useLocation();       // <--- NEw
  // --- HISTORY NAVIGATION LOGIC ---
  // useEffect(() => {
  //   const handlePopState = (event) => {
  //     if (event.state && event.state.view) {
  //       setView(event.state.view);
  //     } else {
  //       setView("home");
  //     }
  //   };
  //   window.addEventListener("popstate", handlePopState);
  //   return () => window.removeEventListener("popstate", handlePopState);
  // }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [view]);

  // useEffect(() => {
  //   if (view === "verify" || isSignInWithEmailLink(auth, window.location.href)) return;
  //   if (window.history.state && window.history.state.view === view) return;
  //   const newUrl = view === "home" ? window.location.pathname : `?page=${view}`;
  //   window.history.pushState({ view }, "", newUrl);
  // }, [view]);


  // --- AUTH LISTENERS & ROLE CHECK ---
  // useEffect(() => {
  //   if (isSignInWithEmailLink(auth, window.location.href)) {
  //     setView("verify"); 
  //   }
  //   const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
  //      console.log(currentUser,"print current user")
  //     setUser(currentUser);
  //     console.log(user,"user login details")
  //     if (currentUser) {
  //       setIsLoginOpen(false);
  //       setIsMenuOpen(false);

  //       // --- RESTRICTED ACCESS CHECK ---
  //       // if (currentUser.email === "yash@nabi.health") {
  //       //   console.log("hiiiiiiiii email", currentUser);
  //       //   setView("therapist_dashboard");
  //       //   view
  //       // }

  //         if (user.role === "user") {
  //         console.log("hiiiiiiiii email", currentUser);
  //         setView("therapist_dashboard");

  //       }
  //       else if(user.role !=="user")
  //         setView("home");
  //     } else {
  //                 console.log("hiiiiiiiii view", view);
  //       if (view === "therapist_dashboard") {
  //         setView("home");
  //       }
  //     }
  //   });
  //   return () => unsubscribe();
  // }, [view]); 

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {

      if (firebaseUser) {

        console.log(firebaseUser, "firebase user");

        const q = query(
          collection(db, "users"),
          where("uid", "==", firebaseUser.uid)
        );

        console.log(q, "firebase q");

        const querySnapshot = await getDocs(q);
        console.log(querySnapshot, "firebase q");

        querySnapshot.forEach((doc) => {
          const userData = doc.data();
          console.log(userData, "userData user");

          sessionStorage.setItem("userData", JSON.stringify(userData));



          // set user if needed
          setUser({
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            ...userData
          });


          if (userData.email === 'tech@nabi.health') {
            navigate("/admin-dashboard");
            console.log("comming here in email");
            setView("admin_dashboard");
          } else if (userData.email.includes('@nabi.health') && (userData.email !== 'tech@nabi.health')) {
            navigate("/therapistdashboard");
            console.log("comming here in userEmaail contqains");

          } else {
            // Removed navigate("/") so regular users can browse freely
          }

          // role condition
          // if (userData.role === "user") {
          //   console.log("usersData role therapist password");
          //   setView("therapist_dashboard");
          // } else {
          //   setView("home");
          // }
        });
      } else {

        setUser(null);
        // Removed navigate("/") so guests can browse freely without being redirected

      }

    });

    return () => unsubscribe();

  }, [navigate]);

  // --- HANDLERS ---
  // const handleSocialLogin = async (provider) => {
  //   console.log("gjbngvk,mhuhgvhj$", provider);

  //   try {
  //     await signInWithPopup(auth, provider)

  //       .then((result) => {
  //         // This gives you a Google Access Token. You can use it to access the Google API.
  //         const credential = GoogleAuthProvider.credentialFromResult(result);
  //         const token = credential.accessToken;
  //         // The signed-in user info.
  //         const user = result.user;
  //         console.log(user, "print user details")

  //         const userData = {
  //           uid: user.uid,
  //           email: user.email,
  //           password: password,
  //           name: user.displayName || "New User",
  //           role: "user",
  //           emailVerified: user.emailVerified,
  //           photoURL: user.photoURL || "",
  //           createdAt: serverTimestamp()
  //         };

  //         console.log(userData, " social login lionks data user created details");


  //         addDoc(collection(db, "users"), {
  //           uid: user.uid,
  //           email: user.email,
  //           name: user.displayName || "New User",
  //           role: "user",
  //           emailVerified: user.emailVerified,
  //           photoURL: user.photoURL || "",
  //           createdAt: serverTimestamp()
  //         });
  //         setUser(userData);


  //         // ...
  //       }).catch((error) => {
  //         // Handle Errors here.
  //         const errorCode = error.code;
  //         const errorMessage = error.message;
  //         // The email of the user's account used.
  //         const email = error.customData.email;
  //         // The AuthCredential type that was used.
  //         const credential = GoogleAuthProvider.credentialFromError(error);
  //         // ...
  //       });


  //   }
  //   catch (error) { alert("Login failed: " + error.message); }
  // };

  // const handleEmailAuth = async (e) => {
  //   e.preventDefault();

  //   try {
  //     if (isSignUpMode) {

  //       const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  //       const user = userCredential.user;

  //       const userData = {
  //         uid: user.uid,
  //         email: user.email,
  //         password: password,
  //         name: user.displayName || "New User",
  //         role: "user",
  //         emailVerified: user.emailVerified,
  //         photoURL: user.photoURL || "",
  //         createdAt: serverTimestamp()

  //       };

  //       console.log(userData, "user  handle email auth created details");

  //       // Save to Firestore
  //       await addDoc(collection(db, "users"), userData);

  //       // Save to state
  //       setUser(userData);

  //     } else {


  //       const userCredential = await signInWithEmailAndPassword(auth, email, password);
  //       const user = userCredential.user;

  //       setUser(user);

  //       console.log(user, "user credentials");

  //     }

  //   } catch (error) {
  //     alert("Authentication failed: " + error.message);
  //   }
  // };
  // console.log(currentUser, "print currentUser data in handle emailsignup")

  const handleLogout = () => {
    signOut(auth);
    setIsMenuOpen(false);
    navigate("/");


  };


  const handleApply = async (e, formDataParam, cvFileParam) => {
    e.preventDefault();
    e.stopPropagation();

    console.log("🟢 handleApply CALLED with:", { formDataParam, cvFileParam });

    setIsSubmitting(true);

    try {
      let cvUrl = "";

      if (cvFileParam) {
        const fileRef = ref(storage, `career_cvs/${Date.now()}_${cvFileParam.name}`);
        await uploadBytes(fileRef, cvFileParam);
        cvUrl = await getDownloadURL(fileRef);
      }

      await addDoc(collection(db, "career_applications"), {
        ...formDataParam,
        jobTitle: "Counseling Psychologist",
        cvUrl,
        timestamp: serverTimestamp()
      });

      await fetch("https://formspree.io/f/yashhemantshinde2005@gmail.com", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formDataParam),
      });

      alert("Application submitted successfully!");

      // Clear form after successful submission
      setFormData({ firstName: "", lastName: "", email: "", message: "" });
      setCvFile(null);

    } catch (error) {
      console.error("Submission error:", error);
      alert("Submission error: " + error.message);
    }

    setIsSubmitting(false);
  };

  //   const handleApply = async (e) => {

  //     e.preventDefault();
  //        e.stopPropagation();
  //       console.log("🟢 handleApply CALLED from App.js - This should print now!");
  //     setIsSubmitting(true);
  //     try {
  //       console.log("prion hererer")

  //       let cvUrl = "";

  //       if (cvFile) {
  //         const fileRef = ref(storage, `career_cvs/${Date.now()}_${cvFile.name}`);
  //         await uploadBytes(fileRef, cvFile);
  //         cvUrl = await getDownloadURL(fileRef);
  //       }


  //       await addDoc(collection(db, "career_applications"), {
  //         ...formData,
  //         jobTitle: "Counseling Psychologist",
  //         cvUrl: cvUrl,   // save file url
  //         timestamp: serverTimestamp()
  //       });
  //       await fetch("https://formspree.io/f/yashhemantshinde2005@gmail.com", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(formData),
  //       });
  //       alert("Application submitted successfully!");
  //       setFormData({ firstName: "", lastName: "", email: "", message: "" });
  // setCvFile(null); 
  //       // navigate("/careers");
  //     } catch (error) {
  //       alert("Submission error: " + error.message);
  //     }
  //     setIsSubmitting(false);
  //   };

  const scrollInsta = (scrollOffset) => {
    if (instaScrollRef.current) {
      instaScrollRef.current.scrollLeft += scrollOffset;
    }
  };
  const scrollStoreCarousel = (scrollOffset) => {
    if (storeCarouselRef.current) {
      storeCarouselRef.current.scrollLeft += scrollOffset;
    }
  };

  useEffect(() => {

    if (location.pathname !== "/") return;
    const id = setInterval(() => {
      if (storeCarouselRef.current) {
        const el = storeCarouselRef.current;
        const maxScroll = el.scrollWidth - el.clientWidth;
        if (maxScroll <= 0) return;
        el.scrollLeft += 1;
        if (el.scrollLeft >= maxScroll) el.scrollLeft = 0;
      }
    }, 45);
    return () => clearInterval(id);
  },
    [location.pathname]);


  // --- CART HELPERS MOVED TO LAYOUT.JS ---
  const { addToCart, setIsCartOpen } = useOutletContext();

  // Animation variants
  const fadeInUp = { hidden: { opacity: 0, y: 60 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } } };
  const staggerContainer = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.2 } } };
  const scaleIn = { hidden: { opacity: 0, scale: 0.8 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeOut" } } };
  const slideInLeft = { hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } } };

  // --- SPECIAL RENDER FOR THERAPIST DASHBOARD ---
  if (location.pathname === "/therapist-dashboard") {
    return (
      <TherapistDashboard user={user} onLogout={handleLogout} />
    );
  }
  return (
    <div className="home-container">

      {/* --- LOGIN MODAL --- */}
      {/* <AnimatePresence>
        {isLoginOpen && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} style={styles.modalOverlay}>
            <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }} exit={{ scale: 0.9 }} style={styles.modalContent}>
              <button onClick={() => setIsLoginOpen(false)} style={styles.closeBtn}>✕</button>
              <h1 style={styles.modalTitle}>{isSignUpMode ? "Sign Up" : "Log In"}</h1>
              <p style={styles.modalSub}>
                {isSignUpMode ? "Already a member?" : "New to Nabi?"}{" "}
                <span style={{ color: '#F07167', cursor: 'pointer', fontWeight: 'normal' }} onClick={() => setIsSignUpMode(!isSignUpMode)}>
                  {isSignUpMode ? "Log In" : "Sign Up"}
                </span>
              </p>
              <form onSubmit={handleEmailAuth} style={styles.emailForm}>
                <input type="email" placeholder="Email" style={styles.inputField} onChange={(e) => setEmail(e.target.value)} required />
                <input type="password" placeholder="Password" style={styles.inputField} onChange={(e) => setPassword(e.target.value)} required />
                <button type="submit" style={styles.submitBtn}>{isSignUpMode ? "Create Account" : "Log In"}</button>
              </form>
              <div style={styles.divider}><div style={styles.line}></div><span style={{ padding: '0 10px', color: '#888', fontSize: '12px' }}>or</span><div style={styles.line}></div></div>
              <div style={styles.socialBtn} onClick={() => handleSocialLogin(googleProvider)}>
                <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" style={styles.iconSm} referrerPolicy="no-referrer" />
                Continue with Google
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence> */}




      {/* --- GLOBAL CART SIDEBAR MOVED TO LAYOUT.JS --- */}

      {/* --- HOME PAGE CONTENT --- */}
      <AnimatePresence mode="wait">
        {location.pathname === "/" && (
          <motion.div key="home" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="home-container">
            {/* HERO SECTION */}
            <motion.section
              className="home-hero"
              initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}
            >
              <motion.div className="home-hero-text" variants={slideInLeft}>
                <h1 className="home-main-title">
                  {user ? `Welcome back, \n${user.displayName || user.email.split('@')[0]}.` : "Introducing \nWorld of Nabi."}
                </h1>
                <p className="home-sub-title">Just Be.</p>
              </motion.div>

              <motion.div className="home-hero-image-container" variants={scaleIn}>
                <img src={APP_ASSETS.heroButterfly} alt="Nabi Hero" className="home-hero-butterfly" />
              </motion.div>
            </motion.section>

            {/* DOWNLOAD SECTION */}
            <motion.section
              className="home-banner home-banner-red"
              initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}
            >
              <div className="home-banner-content">
                <motion.p variants={fadeInUp} className="home-get-started">Get Started!</motion.p>
                <motion.h2 variants={fadeInUp} className="home-banner-heading">
                  A space for reflection,<br />
                  well being and care.<br />
                  Explore what speaks to you.<br />
                </motion.h2>
              </div>
              <div className="home-btn-wrap">
                <motion.button
                  variants={fadeInUp}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => navigate("/nabi-health")}
                  className="home-btn"
                >
                  Explore
                </motion.button>
              </div>
            </motion.section>

            {/* STORE SECTION */}
            <motion.section
              className="home-store-section"
              initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}
            >
              <h3 className="home-store-title">Nabi Store</h3>
              <div className="home-store-carousel-wrap">
                <button className="home-carousel-btn home-carousel-btn-left" onClick={() => scrollStoreCarousel(-280)} aria-label="Previous">‹</button>
                <div className="home-store-scroller no-scrollbar" ref={storeCarouselRef}>
                  {PRODUCTS.map((p) => (
                    <motion.div
                      key={p.id}
                      className="home-store-card"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => {
                        setStoreInitialProductId(p.id);
                        navigate("/store", { state: { initialProductId: p.id } });
                      }}
                    >
                      <img src={p.image} alt={p.name} className="home-store-img" />
                    </motion.div>
                  ))}
                </div>
                <button className="home-carousel-btn home-carousel-btn-right" onClick={() => scrollStoreCarousel(280)} aria-label="Next">›</button>
              </div>
              <div className="home-btn-wrap">
                <motion.button
                  className="home-btn home-btn-red"
                  onClick={() => navigate("/store")}
                >
                  Explore
                </motion.button>
              </div>
            </motion.section>

            <motion.section
              className="home-banner home-banner-orange"
              initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}
            >
              <div className="home-banner-content">
                <motion.p variants={fadeInUp} className="home-get-started">Why It Matters!</motion.p>
                <motion.h2 variants={fadeInUp} className="home-banner-heading">
                  A space to understand emotional and psychological safety.<br />
                  Explore how safe environments empower individuals to grow.<br />
                </motion.h2>
              </div>
              <div className="home-btn-wrap">
                <motion.button
                  variants={fadeInUp}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => navigate("/training")}
                  className="home-btn"
                >
                  Explore
                </motion.button>
              </div>
            </motion.section>

            {/* blogs sections */}
            <motion.section
              className="home-banner home-banner-white"
              initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}
            >
              <div className="home-banner-content">
                <motion.p variants={fadeInUp} className="home-get-started">Nabi Stories!</motion.p>
                <motion.h2 variants={fadeInUp} className="home-banner-heading">
                  A window to what speaks to your soul.<br />
                </motion.h2>
              </div>
              <div className="home-btn-wrap">
                <motion.button
                  variants={fadeInUp}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => navigate("/blog")}
                  className="home-btn home-btn-red"
                >
                  Explore
                </motion.button>
              </div>
            </motion.section>

            {/* INSTAGRAM SECTION WITH CAROUSEL */}
            <motion.section
              className="home-instagram-section"
              initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeInUp}
            >
              <Instagramfeeddata key={Date.now()} />
            </motion.section>
          </motion.div>
        )}
      </AnimatePresence>


    </div>
  );
}

function InstaCard({ post }) {
  const [hover, setHover] = useState(false);
  return (
    <motion.div
      className="home-post-card"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      whileHover={{ scale: 1.05 }}
    >
      <img src={post.media_url} alt="Insta" className="home-post-image" />
      <AnimatePresence>
        {hover && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="home-post-overlay">
            <p className="home-post-overlay-text">{post.caption}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

// --- UPDATED STYLES ---
const styles = {
  // ... (Previous styles for Hero, Navbar, etc. remain the same) ...
  page: { backgroundColor: "#FFF7F1", color: "#003049", overflowX: "hidden", fontFamily: "'Syne', sans-serif", fontWeight: "400" },
  navbar: { position: "fixed", top: 0, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 50px", backgroundColor: "rgba(255, 247, 241, 0.95)", zIndex: 1000, boxSizing: "border-box", fontFamily: "'Syne', sans-serif", fontWeight: "60px" },
  logo: { fontWeight: "60", flex: 1, cursor: "pointer", display: 'flex', alignItems: 'center', color: '#003049', fontFamily: 'Syne, sans-serif' },
  navLinks: { fontWeight: "60", display: "flex", gap: "40px", justifyContent: "center", alignItems: "center" },
  cornerlogo:

    { width: "40px", height: "40px", marginRight: "5px", },
  navItem: { fontWeight: "400", cursor: "pointer", fontSize: "15px", color: "#003049", fontFamily: 'Syne, sans-serif' },
  navIcons: { display: "flex", gap: "25px", flex: 1, justifyContent: "flex-end", fontSize: "14px", color: '#003049' },
  loginContainer: { fontWeight: "60", position: "relative", display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" },
  userIcon: { background: "#F07167", color: "white", borderRadius: "50%", width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", fontSize: "14px" },
  avatar: { width: "100%", height: "100%", objectFit: "cover" },
  loginText: { fontFamily: "'Syne', sans-serif", fontSize: "16px", color: "#F07167" },
  dropdownMenu: { position: "absolute", top: "45px", right: 0, backgroundColor: "white", borderRadius: "5px", boxShadow: "0 10px 25px rgba(0,0,0,0.2)", width: "200px", padding: "5px 0", textAlign: "left", zIndex: 1001 },
  moreDropdown: { position: "absolute", top: "100%", left: "0", backgroundColor: "white", borderRadius: "5px", boxShadow: "0 10px 25px rgba(0,0,0,0.2)", padding: "10px 0", minWidth: "160px", zIndex: 1001, marginTop: "10px" },
  menuItem: { fontFamily: "'Syne', sans-serif", fontSize: "16px", padding: "10px 20px", cursor: "pointer", color: "#003049", transition: "background 0.2s", textAlign: "left" },




  // --- EXISTING STYLES ---
  badge: {
    background: '#F07167',
    color: 'white',
    borderRadius: '50%',
    fontSize: '10px',
    width: '16px',
    height: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    fontWeight: 'normal'
  },
  careersPage: {
    padding: "120px 100px",
    paddingLeft: "50px",
    paddingRight: "50px",
    backgroundColor: "#003049",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "40px"
  },
  careerHeroCard: {
    backgroundColor: "#FFF7F1",
    borderRadius: "48px",
    padding: "28px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    maxWidth: "1600px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
    height: "400px",
    gap: "32px"
  },
  careerHeroImgContainer: { width: "360px", height: "360px", borderRadius: "50%", overflow: "hidden", flexShrink: 0, boxShadow: "0 20px 40px rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center" },
  careerHeroImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
    display: "block"
  },
  careerHeroText: {
    width: "40%",
    padding: "40px 40px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "left"
  },
  careerMainHeading: {
    fontSize: "2.8rem",
    fontWeight: "400",
    margin: "0 0 24px 0",
    lineHeight: "1.2",
    color: "#003049"
  },
  careerSubHeading: {
    fontFamily: "'Syne', sans-serif",
    fontWeight: "400",
    fontSize: "1.1rem",
    marginTop: "10px",
    color: "#003049",
    opacity: 0.9,
    lineHeight: "1.2"
  },
  jobListingContainer: {
    width: "90%",
    display: "flex",
    justifyContent: "center"
  },
  jobCard: {
    backgroundColor: "#FFF7F1",
    borderRadius: "48px",
    padding: "30px 30px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
    maxWidth: "1500px",
    width: "100%",
    opacity: "90%",
  },
  jobTitleText: {
    fontSize: "2.2rem",
    marginBottom: "24px",
    fontWeight: "400",
    color: "#003049"
  },
  jobDescriptionText: {
    fontFamily: "'Syne', sans-serif",
    fontWeight: "400",
    fontSize: "1.05rem",
    lineHeight: "1.2",
    color: "#4a4a4a",
    marginBottom: "48px"
  },
  learnMoreBtn: {
    width: "100%",
    padding: "16px 0",
    backgroundColor: "#F07167",
    color: "white",
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    fontSize: "1.1rem",
    fontWeight: "60",
    transition: "background 0.3s"
  },
  uploadLabel: { display: "inline-block", padding: "10px 20px", border: "1px solid #003049", borderRadius: "8px", cursor: "pointer", fontSize: "14px" },
  aboutPage: { padding: "120px 15% 80px 15%", backgroundColor: "#FFF7F1", color: "#003049" },
  jdContainer: { marginBottom: "60px" },
  jdMainTitle: { fontSize: "2.4rem", marginBottom: "30px", fontWeight: "normal" },
  jdParagraph: { fontSize: "1.1rem", lineHeight: "1.5", marginBottom: "20px" },
  jdSubTitle: { fontSize: "1.5rem", marginTop: "40px", marginBottom: "15px", borderBottom: "2px solid #F07167", display: "inline-block", fontWeight: "normal" },
  jdList: { fontSize: "1.05rem", lineHeight: "1.5" },
  applicationFormSection: { fontWeight: "normal", padding: "50px", backgroundColor: "white", borderRadius: "30px", boxShadow: "0 10px 30px rgba(0,0,0,0.2)" },
  applicationForm: { fontWeight: "normal", display: "flex", flexDirection: "column", gap: "10px" },
  formRow: { display: "flex", gap: "10px" },
  formInput: { margin: "0", padding: "15px", borderRadius: "10px", border: "1px solid #ddd", width: "100%", outline: "none" },
  formSubmitBtn: { padding: "15px", backgroundColor: "#F07167", color: "white", border: "none", borderRadius: "10px", fontWeight: "normal", cursor: "pointer" },

  modalOverlay: { position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" },
  modalContent: { fontFamily: "'Syne', sans-serif", fontWeight: "normal", backgroundColor: "#FFF7F1", width: "400px", padding: "40px", borderRadius: "12px", position: "relative", textAlign: "center" },
  closeBtn: { position: "absolute", top: "20px", right: "20px", border: "none", background: "none", cursor: "pointer", fontSize: "18px" },
  modalTitle: { fontSize: "28px", marginBottom: "10px", fontWeight: "normal" },
  modalSub: { fontSize: "13px", marginBottom: "25px" },
  emailForm: { display: "flex", flexDirection: "column", gap: "12px", marginBottom: "20px" },
  inputField: { padding: "12px", borderRadius: "6px", border: "1px solid #ddd", fontSize: "14px" },
  submitBtn: { fontWeight: "40px", padding: "12px", borderRadius: "6px", border: "none", backgroundColor: "#003049", color: "white", cursor: "pointer" },
  socialBtn: { display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", border: "1px solid #ccc", padding: "10px", borderRadius: "5px", marginBottom: "10px", cursor: "pointer", fontSize: "14px" },
  iconSm: { width: "18px", height: "18px", objectFit: "contain" },
  divider: { display: "flex", alignItems: "center", margin: "15px 0" },
  line: { flex: 1, height: "1px", backgroundColor: "#ddd" },

  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 3000 },
  cartSidebar: { fontWeight: "normal", position: 'fixed', top: 0, right: 0, width: '400px', height: '100vh', background: 'white', zIndex: 3001, padding: '30px', display: 'flex', flexDirection: 'column', boxShadow: '-5px 0 20px rgba(0,0,0,0.1)' },
  cartHeader: { fontWeight: "normal", display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee', paddingBottom: '20px', marginBottom: '20px' },
  cartItemsScroll: { flex: 1, overflowY: 'auto', marginBottom: '20px' },
  cartItemRow: { display: 'flex', gap: '15px', marginBottom: '20px', borderBottom: '1px solid #f9f9f9', paddingBottom: '15px' },
  cartItemImg: { width: '70px', height: '70px', objectFit: 'cover', borderRadius: '8px' },
  cartItemName: { margin: '0 0 5px', fontSize: '14px', fontWeight: 'normal' },
  trashBtn: { border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px' },
  qtyControlSm: { display: 'flex', border: '1px solid #ddd', borderRadius: '4px', width: '80px', justifyContent: 'space-between', padding: '2px 8px', marginTop: '5px', fontSize: '12px' },

  cartFooter: {
    borderTop: '1px solid #eee',
    paddingTop: '20px',
    position: 'sticky',
    bottom: '45px',
    background: 'white'
  }, checkoutBtn: { width: '100%', padding: '12px', backgroundColor: '#F07167', color: 'white', border: 'none', borderRadius: '5px', fontWeight: '40px', cursor: 'pointer', marginBottom: '10px' },
};